import { QueryFunctionContext, useInfiniteQuery } from 'react-query';

import { list as listFn } from './service';

interface CompanyArguments {
  eventId: string;
  searchValue?: string;
}
type CompanyKey = ['companies', CompanyArguments];

const companyQuery = {
  getQueryKey: (param: CompanyArguments): CompanyKey => ['companies', param],
  queryFn: ({ pageParam = 0, queryKey: [, param] }: QueryFunctionContext<CompanyKey>) =>
    listFn(pageParam, param.eventId, param.searchValue),
};

export const useCompanies = (eventId: string, searchValue: string) =>
  useInfiniteQuery({
    queryKey: companyQuery.getQueryKey({ eventId, searchValue }),
    queryFn: companyQuery.queryFn,
  });
